import { useQuery } from '@tanstack/react-query';
import { CategoryItem } from '~/.server/api/routers/workspace';

export function useCategories() {
  return useQuery<CategoryItem[]>({
    queryKey: ['categories'],
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
